import React from "react";
import styled from 'styled-components'
// reactstrap components
import {
  Container,
  Row,
} from "reactstrap";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import work1 from 'assets/img/examples/work1.jpg'
import work2 from 'assets/img/examples/work2.jpg'
import work3 from 'assets/img/examples/work3.jpg'
import work4 from 'assets/img/examples/work4.jpg'
import work5 from 'assets/img/examples/work5.jpg'
import work6 from 'assets/img/examples/work6.jpg'
import work7 from 'assets/img/examples/work7.jpg'
import { useTranslation } from 'react-i18next';
const MainText = styled.h3`
    text-align: center;
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`
const Images = styled.img`
  width: 100%;
  height: 600px;
  margin-bottom: 20px;
`


function ProfilePage() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
       <MainText>{t('OurWorks')} </MainText>
      </Row>
      <Row>
      <Images src={work1} alt="work" />
      <Images src={work2} alt="work" />
      <Images src={work3} alt="work" />
      <Images src={work4} alt="work" />
      <Images src={work5} alt="work" />
      <Images src={work6} alt="work" />
      <Images src={work7} alt="work" />
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
